// import { useEffect, useState } from "react";
// import axiosClient from "../axiosClient";
// import {
//   TextField,
//   Button,
//   Typography,
//   Container,
//   Box,
//   Alert,
// } from "@mui/material";
// import { useThemeContext } from "../context/ThemeContext";
// import { Tooltip, IconButton } from "@mui/material";
// import Brightness4Icon from "@mui/icons-material/Brightness4"; // Moon
// import Brightness7Icon from "@mui/icons-material/Brightness7"; // Sun

// const ResetPassword = () => {
//   const { mode, toggleTheme } = useThemeContext();
//   const params = new URLSearchParams(window.location.search);
//   const resetToken = params.get("token"); // Extract the reset token from the URL

//   const [newPassword, setNewPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");
//   const [errorMessage, setErrorMessage] = useState("");
//   const [successMessage, setSuccessMessage] = useState("");

//   // Optional: Validate the token when the component mounts
//   useEffect(() => {
//     if (!resetToken) {
//       setErrorMessage("Invalid or missing token.");
//     }
//   }, [resetToken]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Clear previous messages and set loading state
//     setErrorMessage("");
//     setSuccessMessage("");

//     if (newPassword !== confirmPassword) {
//       setErrorMessage("Passwords do not match.");
//       return;
//     }

//     try {
//       const payload = { password: newPassword, token: resetToken };
//       const response = await axiosClient.put("/auth/reset_password", payload);

//       if (response.status === 200) {
//         setSuccessMessage("Password reset successfully!");
//         setNewPassword(""); // Clear the password fields
//         setConfirmPassword("");
//       }
//       else {
//         throw new Error(response.status);
//       }
//     } catch (error) {
//       if (error.response && error.response.data) {
//         const errorMessage =
//           error.response.data.token || "An unexpected error occurred.";
//         setErrorMessage(errorMessage);
//       } else {
//         setErrorMessage("Network error. Please try again later.");
//       }
//     }
//   };

//   return (
//     <Container maxWidth="sm">

//       <Box
//         component="form"
//         onSubmit={handleSubmit}
//         sx={{
//           mt: 4,
//           p: 3,
//           boxShadow: 2,
//           borderRadius: 2,
//           backgroundColor: "#fff",
//           position: "relative",
//         }}
//       >
//         {/* Theme Toggle Button placed nicely inside form */}
//         <Box sx={{ position: "absolute", top: 16, right: 16 }}>
//           <Tooltip title={`Switch to ${mode === "light" ? "Dark" : "Light"} Mode`}>
//             <IconButton onClick={toggleTheme} color="inherit">
//               {mode === "light" ? <Brightness4Icon /> : <Brightness7Icon />}
//             </IconButton>
//           </Tooltip>
//         </Box>
//         <Typography variant="h5" gutterBottom align="center">
//           Reset Your Password
//         </Typography>

//         <TextField
//           label="New Password"
//           type="password"
//           variant="outlined"
//           fullWidth
//           margin="normal"
//           value={newPassword}
//           onChange={(e) => setNewPassword(e.target.value)}
//           required
//         />

//         <TextField
//           label="Confirm Password"
//           type="password"
//           variant="outlined"
//           fullWidth
//           margin="normal"
//           value={confirmPassword}
//           onChange={(e) => setConfirmPassword(e.target.value)}
//           required
//         />

//         {errorMessage && (
//           <Alert severity="error" sx={{ mt: 2 }}>
//             {errorMessage}
//           </Alert>
//         )}

//         {successMessage && (
//           <Alert severity="success" sx={{ mt: 2 }}>
//             {successMessage}
//           </Alert>
//         )}

//         <Button
//           type="submit"
//           variant="contained"
//           fullWidth
//           color="primary"
//           sx={{ mt: 3 }}
//         >
//           Reset Password
//         </Button>
//       </Box>
//     </Container>
//   );
// };

// export default ResetPassword;


import React, { useState } from "react";
import { TextField, Button, Box, Typography, Card, CardContent, Alert } from "@mui/material";
import axiosClient from "../axiosClient";
import { useTranslation } from "react-i18next";

export default function ResetPassword() {
  const { t } = useTranslation();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [status, setStatus] = useState({ type: "", msg: "" });

  // ✅ Extract UID and TOKEN from the URL string
  // URL: /reset-password/MTI/cl7p-867...
  const pathParts = window.location.pathname.split("/");
  const uidb64 = pathParts[2]; // The encoded User ID
  const token = pathParts[3];  // The secret token

  const handleUpdate = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setStatus({ type: "error", msg: t("Passwords do not match") });
      return;
    }

    try {
      // ✅ Call the new backend endpoint: password-reset-confirm
      await axiosClient.post(`auth/password-reset-confirm/${uidb64}/${token}/`, {
        password: password
      });
      
      setStatus({ type: "success", msg: t("Password updated! Redirecting to login...") });
      
      // Redirect back to login after 2 seconds
      setTimeout(() => {
        window.location.href = "/";
      }, 2000);
      
    } catch (err) {
      console.error(err);
      setStatus({ type: "error", msg: t("Link is invalid or has expired.") });
    }
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center" height="100vh" bgcolor="#f4f6f8">
      <Card sx={{ width: 400, p: 2, boxShadow: 15, borderRadius: 3 }}>
        <CardContent>
          <Typography variant="h5" mb={3} textAlign="center" fontWeight="bold">
            {t("Set New Password")}
          </Typography>

          {status.msg && (
            <Alert severity={status.type} sx={{ mb: 2 }}>{status.msg}</Alert>
          )}

          <form onSubmit={handleUpdate}>
            <TextField
              fullWidth
              type="password"
              label={t("New Password")}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              sx={{ mb: 2 }}
              required
            />
            <TextField
              fullWidth
              type="password"
              label={t("Confirm Password")}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              sx={{ mb: 3 }}
              required
            />
            <Button 
              fullWidth 
              variant="contained" 
              type="submit" 
              size="large"
              sx={{ py: 1.5, fontWeight: "bold" }}
            >
              {t("Update Password")}
            </Button>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
}